const milestones = [
  {
    year: "2024",
    title: "从一份文档开始",
    desc: "把当天刷到的消息按时间顺序整理成文档，先解决「信息太碎」这一个问题。",
  },
  {
    year: "2025",
    title: "栏目化与分类",
    desc: "内容按恋情、作品、综艺、造型等方向拆分栏目，读者可以只看自己关心的那一类。",
  },
  {
    year: "2026",
    title: "合集与榜单并行",
    desc: "每日合集负责不漏事，热门榜单负责抓重点，两条线互相补位，形成稳定的阅读节奏。",
  },
  {
    year: "下一步",
    title: "把核查做得更扎实",
    desc: "引入更完整的公开信息比对流程，让每一条结论都能追溯到具体来源。",
  },
];

export default function TimelineSection() {
  return (
    <section className="rounded-card bg-background-100 px-5 py-12 md:px-10 md:py-14">
      <div className="mx-auto max-w-[1000px]">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-route-line text-[11px]"></i>
            </span>
            发展理念
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一步一步，把整理这件事做扎实
          </h2>
        </div>

        <ol className="mt-10 flex flex-col gap-0">
          {milestones.map((item, index) => (
            <li key={item.year} className="relative flex gap-5 pb-8 last:pb-0">
              <div className="flex flex-col items-center">
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                    index === milestones.length - 1
                      ? "bg-accent-500 text-accent-950"
                      : "bg-primary-500 text-background-50"
                  }`}
                >
                  {index + 1}
                </span>
                {index < milestones.length - 1 && (
                  <span className="mt-1 w-px flex-1 bg-background-300"></span>
                )}
              </div>
              <div className="flex-1 pt-1">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <span className="rounded-full bg-background-50 px-2.5 py-0.5 text-xs text-foreground-600">
                    {item.year}
                  </span>
                </div>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}